import { Component, AfterViewInit, OnDestroy, OnInit, ViewChild, ElementRef } from '@angular/core';
import { NavController, NavParams, App } from 'ionic-angular';
import { Card } from '../../app/models/Card';
import { CardTransaction } from '../../app/models/CardTransaction';
import { ModalDirective } from '../../../node_modules/ngx-bootstrap/modal';
import { TransactionType } from '../../app/models/TransactionType';
import { PaytronBackendService } from '../../providers/paytron-backend/paytron-backend.service';
import { HttpErrorResponse } from '../../../node_modules/@angular/common/http';
import { BaseChartDirective } from '../../../node_modules/ng2-charts';
import { Utils } from '../../providers/paytron-backend/utils';
import { Chart } from '../../app/models/Chart';
import { TableDirective } from '../../directives/table-directive';
import { NavControllerService } from '../../providers/nav-controller/navControllerService';
import { AccountHolder } from '../../app/models/AccountHolder';
import { CurrentAccount } from '../../app/models/CurrentAccount';
import { Customer } from '../../app/models/Customer';
import { User } from '../../app/models/User';
import { Storage } from '../../../node_modules/@ionic/storage';
import { CardTransactionProduct } from '../../app/models/CardTransactionProduct';
import { PoS } from '../../app/models/PoS';
import { RegisterActivity } from '../../app/models/RegisterActivity';
import { AlertsHolder } from '../../app/models/AlertsHolder';
import { TranslateService } from '@ngx-translate/core';
import { ConfigService } from '../../providers/config/config.service';
import { Observable } from 'rxjs';
import { CardStatus } from '../../app/models/CardStatus';
import { PricelistProduct } from '../../app/models/PriceListProduct';
import { Coupon } from '../../app/models/Coupon';
import { moment } from 'ngx-bootstrap/chronos/test/chain';

@Component({
  selector: 'page-card-details',
  templateUrl: 'card-details.html',
})
export class CardDetailsPage implements AfterViewInit, OnDestroy, OnInit {
  @ViewChild(TableDirective)
  private table: TableDirective;

  @ViewChild(BaseChartDirective)
  private baseChart: BaseChartDirective;

  @ViewChild('rechargeModal')
  private rechargeModal: ModalDirective;

  @ViewChild('rechargeInput')
  rechargeInput: ElementRef;

  @ViewChild('paymentInput')
  paymentInput: ElementRef;

  @ViewChild('securityDepositInput')
  securityDepositInput: ElementRef;

  @ViewChild('dischargeInput')
  dischargeInput: ElementRef;

  @ViewChild('paymentModal')
  private paymentModal: ModalDirective;

  @ViewChild('securityDepositModal')
  private securityDepositModal: ModalDirective;

  @ViewChild('reverseModal')
  private reverseModal: ModalDirective;

  @ViewChild('dischargeModal')
  private dischargeModal: ModalDirective;

  @ViewChild('giveBackModal')
  private giveBackModal: ModalDirective;

  @ViewChild('insertCardModal')
  private insertCardModal: ModalDirective;

  @ViewChild('storedDataComparisonModal')
  private storedDataComparisonModal: ModalDirective;

  private pageName: string = 'page-card-details';

  private currentCard: Card;
  private currentCardUuid: string;
  private currentAccount: CurrentAccount;
  private accountHolder: AccountHolder;
  private accountHolderType = AccountHolder;
  private cardOwner: User | Customer;
  private alertsHolder: AlertsHolder;
  private currentTransaction = new CardTransaction();
  private currentTransactions: CardTransaction[] = [];
  private transactionProduct = new CardTransactionProduct();
  private cardTransactionProducts: CardTransactionProduct[];
  private securityDeposits: CardTransaction[];
  private cardsActivityChart: any;
  private pos: PoS;
  private chart;
  private productList: any;
  private priceListProducts: PricelistProduct[] = [];
  private secondCircuit = false;
  private totalDeposit = 0;
  private closedActivity: any;
  private cardReaderWebSocket: WebSocket;
  private dataStoredInCard: any;
  private reversalNotes: string;
  private writingOnCard = false;

  private navControllerService: NavControllerService;
  private isAuthorizedToUserRelatedPages: boolean;

  constructor(
    public navCtrl: NavController,
    public navParams: NavParams,
    private backendService: PaytronBackendService,
    private app: App,
    public storage: Storage,
    private configService: ConfigService,
    private utils: Utils,
    private translate: TranslateService
  ) {
    this.currentCard = new Card();
    this.currentAccount = new CurrentAccount();
    this.currentCardUuid = navParams.get('cardUuid');
    this.accountHolder = navParams.get('accountHolder');
    this.chart = new Chart();
    this.navControllerService = new NavControllerService(app, storage);
    this.navControllerService.isAuthorizedToUserRelatedPages().then((isAuthorized: boolean) => {
      this.isAuthorizedToUserRelatedPages = isAuthorized;
    });
    this.alertsHolder = new AlertsHolder(translate);
    this.storage.get('PoS').then((pos: PoS) => {
      this.pos = pos;
      this.loadProductList(pos);
    });
    this.storage.get('registerActivity').then((activity: RegisterActivity) => {
      this.closedActivity = !activity || activity.closeDate;
    });
  }

  private loadCurrentCard() {
    this.backendService.getCard(this.currentCardUuid, true).subscribe(
      (data) => {
        this.currentCard = data;
        this.loadTransactions();
        this.getSecurityDepositsByCard();
        this.backendService.getCurrentAccountByCard(this.currentCard).subscribe(
          (currentAccount: CurrentAccount) => {
            this.currentAccount = currentAccount;
          },
          (err: HttpErrorResponse) => {}
        );
      },
      (err: HttpErrorResponse) => {}
    );
  }

  private loadTransactions() {
    this.backendService.getCardTransactionsByCard(this.currentCard).subscribe(
      (transactions) => {
        this.currentTransactions = transactions;
        // this.refreshChart();
        this.table.refreshTable();
      },
      (err: HttpErrorResponse) => {}
    );
  }

  private loadProductList(pos: PoS) {
    this.priceListProducts = [];
    pos &&
      this.backendService.getPriceListsProductByPos(pos).subscribe(
        (pricelistProducts: PricelistProduct[]) => {
          this.priceListProducts = pricelistProducts;
        },
        (err: HttpErrorResponse) => {}
      );
  }

  onRadioChange(data) {
    this.secondCircuit = data;
  }

  onProductSelect(pricelist: PricelistProduct) {
    this.currentTransaction.movement = pricelist.price;
    this.transactionProduct.product = pricelist.product;
    this.transactionProduct.unitTransactionPrice = pricelist.price;
  }

  ngOnInit(): void {
    this.table.dtOptions = {
      pagingType: 'full_numbers',
      pageLength: 10,
    };
    this.loadCurrentCard();

    this.rechargeModal.onShown.subscribe(() => this.utils.focus(this.rechargeInput));
    this.paymentModal.onShown.subscribe(() => this.utils.focus(this.paymentInput));
    this.securityDepositModal.onShown.subscribe(() => this.utils.focus(this.securityDepositInput));
    this.dischargeModal.onShown.subscribe(() => this.utils.focus(this.dischargeInput));
  }

  ngAfterViewInit(): void {}
  ngOnDestroy(): void {
    if (this.cardReaderWebSocket) {
      this.cardReaderWebSocket.close();
    }
  }

  ionViewDidEnter() {
    this.openStoredDataComparisonCardListenerWebSocket();
  }

  submitPayment(paymentBtn: HTMLButtonElement) {
    paymentBtn.disabled = true;
    this.submitTransaction(paymentBtn, (currentBalanceAmount: number, currentBalanceVersion: number) => {
      this.currentTransaction.pos = this.pos;
      this.currentTransaction.type = TransactionType.Payment;
      this.currentTransaction.card = this.secondCircuit ? this.currentCard.secondCircuitUuid : this.currentCard.uuid;
      this.currentTransaction.balanceSnapshot = currentBalanceAmount;
      this.currentTransaction.balanceVersion = currentBalanceVersion + 1;
      this.currentTransaction.cardTransactionProducts.push(this.transactionProduct);
      return this.backendService
        .addPaymentTransaction(this.currentTransaction)
        .map<CardTransaction, CardTransaction[]>((data: CardTransaction) => {
          return Array.of(data);
        });
    });
  }

  submitSecurityDeposit(securityDepositBtn: HTMLButtonElement) {
    securityDepositBtn.disabled = true;
    this.submitTransaction(securityDepositBtn, (currentBalanceAmount: number, currentBalanceVersion: number) => {
      this.currentTransaction.pos = this.pos;
      this.currentTransaction.type = TransactionType.SecurityDeposit;
      this.currentTransaction.card = this.secondCircuit ? this.currentCard.secondCircuitUuid : this.currentCard.uuid;
      this.currentTransaction.balanceSnapshot = currentBalanceAmount;
      this.currentTransaction.balanceVersion = currentBalanceVersion + 1;
      return this.backendService
        .addSecurityDepositTransaction(this.currentTransaction)
        .map<CardTransaction, CardTransaction[]>((data: CardTransaction) => {
          return Array.of(data);
        });
    });
  }

  submitDischarge(dischargeBtn: HTMLButtonElement) {
    dischargeBtn.disabled = true;
    this.currentTransaction.type = TransactionType.Discharge;
    this.submitTransaction(dischargeBtn, (currentBalanceAmount: number, currentBalanceVersion: number) => {
      this.currentTransaction.pos = this.pos;
      this.currentTransaction.type = TransactionType.Discharge;
      this.currentTransaction.card = this.currentCard.uuid;
      this.currentTransaction.balanceSnapshot = currentBalanceAmount;
      this.currentTransaction.balanceVersion = currentBalanceVersion + 1;
      return this.backendService
        .addDischargeTransaction(this.currentTransaction)
        .map<CardTransaction, CardTransaction[]>((data: CardTransaction) => {
          this.backendService.getCardTransactionReceiptPdf(data).subscribe(
            (blob: Blob) => {
              const element = document.createElement('a');
              element.href = URL.createObjectURL(blob);
              const date = moment().format('DD-MM-YYYY, h:mm:ss');
              element.download = data.type + ' ' + date + '.pdf';
              document.body.appendChild(element);
              element.click();
            },
            (err: HttpErrorResponse) => {}
          );
          return Array.of(data);
        });
    });
  }

  dischargeWithoutCard(dischargeBtn: HTMLButtonElement) {
    this.closeInsertCardModal();
    dischargeBtn.disabled = true;
    this.currentTransaction.pos = this.pos;
    this.currentTransaction.type = TransactionType.Discharge;
    this.currentTransaction.card = this.currentCard.uuid;
    this.currentTransaction.balanceSnapshot = this.utils.toCents(new Number(this.currentCard.balance).valueOf());
    this.currentTransaction.balanceVersion = 2147483647;
    this.currentTransaction.force = true;
    this.backendService.addDischargeTransaction(this.currentTransaction).subscribe(
      (card) => {
        this.loadCurrentCard();
        this.closeAllModals();
        dischargeBtn.disabled = false;
        this.alertsHolder.show('The card was discharged and automatically blocked.', 'danger');
      },
      (err: HttpErrorResponse) => {}
    );
  }

  submitRecharge(rechargeBtn: HTMLButtonElement) {
    rechargeBtn.disabled = true;
    this.submitTransaction(rechargeBtn, (currentBalanceAmount: number, currentBalanceVersion: number) => {
      this.currentTransaction.pos = this.pos;
      this.currentTransaction.type = TransactionType.Recharge;
      this.currentTransaction.card = this.currentCard.uuid;
      this.currentTransaction.balanceSnapshot = currentBalanceAmount;
      this.currentTransaction.balanceVersion = currentBalanceVersion + 1;
      return this.backendService
        .addRechargeTransaction(this.currentTransaction)
        .map<CardTransaction, CardTransaction[]>((data: CardTransaction) => {
          this.backendService.getCardTransactionReceiptPdf(data).subscribe(
            (blob: Blob) => {
              const element = document.createElement('a');
              element.href = URL.createObjectURL(blob);
              const date = moment().format('DD-MM-YYYY, h:mm:ss');
              element.download = data.type + ' ' + date + '.pdf';
              document.body.appendChild(element);
              element.click();
            },
            (err: HttpErrorResponse) => {}
          );
          return Array.of(data);
        });
    });
  }

  submitReversal(event) {
    this.submitTransaction(event, (currentBalanceAmount: number, currentBalanceVersion: number) => {
      let reversalTransaction = new CardTransaction();
      reversalTransaction.type = TransactionType.Reversal;
      reversalTransaction.reversed_transaction = this.currentTransaction.uuid;
      reversalTransaction.card = this.currentCard.uuid;
      reversalTransaction.pos = this.pos;
      reversalTransaction.notes = this.reversalNotes;
      reversalTransaction.balanceSnapshot = currentBalanceAmount;
      reversalTransaction.balanceVersion = currentBalanceVersion + 1;
      return this.backendService
        .addReversalTransaction(reversalTransaction)
        .map<CardTransaction, CardTransaction[]>((data: CardTransaction) => {
          return Array.of(data);
        });
    });
  }

  submitGiveBackAll(giveBackBtn: HTMLButtonElement) {
    giveBackBtn.disabled = true;
    this.submitTransaction(giveBackBtn, (currentBalanceAmount: number, currentBalanceVersion: number) => {
      return this.backendService.giveBackAllDepositsByCard(
        this.currentCard,
        currentBalanceAmount,
        currentBalanceVersion + 1,
        this.pos
      );
    });
  }

  private sendCardReaderHaltCommand(cardReaderWebSocket: WebSocket) {
    cardReaderWebSocket.send(
      JSON.stringify({
        messageType: 'command',
        message: {
          command: 'HALT',
        },
      })
    );
  }

  private sendCardReaderReadValuesCommand(cardReaderWebSocket: WebSocket, valuesToRead: string[]) {
    cardReaderWebSocket.send(
      JSON.stringify({
        messageType: 'command',
        message: {
          command: 'READ_VALUES',
          parameters: {
            valuesToRead: valuesToRead,
          },
        },
      })
    );
  }

  private sendCardReaderWriteValuesCommand(
    cardReaderWebSocket: WebSocket,
    card: Card,
    newBalance: number,
    lastTransaction: CardTransaction
  ) {
    let movementCents: number = this.utils.toCents(lastTransaction.movement.valueOf());
    cardReaderWebSocket.send(
      JSON.stringify({
        messageType: 'command',
        message: {
          command: 'WRITE_VALUES',
          parameters: {
            cardId: card.uuid,
            balance: {
              amount: newBalance,
              version: card.balanceVersion,
            },
            lastTransaction: {
              id: lastTransaction.uuid,
              posId: lastTransaction.pos.uuid,
              amount: movementCents,
              type: lastTransaction.type,
            },
          },
        },
      })
    );
  }

  private sendBlockedCardStatusCardReaderWriteValuesCommand(cardReaderWebSocket: WebSocket, card: Card) {
    cardReaderWebSocket.send(
      JSON.stringify({
        messageType: 'command',
        message: {
          command: 'WRITE_VALUES',
          parameters: {
            cardId: card.uuid,
            cardStatus: 'Blocked',
          },
        },
      })
    );
  }

  private blockCard(webSocket: WebSocket, card: Card) {
    card.status = CardStatus.Blocked;
    card.currentAccountUuid = this.currentAccount.uuid;
    this.backendService.saveOrUpdateCard(card).subscribe(
      () => {
        this.alertsHolder.show('The card was automatically blocked.', 'danger');
      },
      (error: any) => {
        console.error(error);
        this.alertsHolder.show('Do not use the card again. Block it manually.', 'danger');
      }
    );
    this.sendBlockedCardStatusCardReaderWriteValuesCommand(webSocket, card);
  }

  submitTransaction(
    btnEvent: HTMLButtonElement,
    createAddTransactionObservable: (
      currentBalanceAmount: number,
      currentBalanceVersion: number
    ) => Observable<CardTransaction[]>
  ) {
    if (this.secondCircuit) {
      this.backendService
        .getCard(this.currentCard.secondCircuitUuid)
        .subscribe(
          (data) => {
            this.submitTransactionAfterCardDetection(data, btnEvent, createAddTransactionObservable);
          },
          (err: HttpErrorResponse) => {
            this.alertsHolder.show('Transaction Rejected', 'danger');
            this.currentTransaction = new CardTransaction();
            this.transactionProduct = new CardTransactionProduct();
          }
        )
        .add(() => {
          btnEvent.disabled = false;
        });
    } else {
      this.submitTransactionAfterCardDetection(this.currentCard, btnEvent, createAddTransactionObservable);
    }
  }

  private submitTransactionAfterCardDetection(
    actualCard: Card,
    btnEvent: HTMLButtonElement,
    createAddTransactionObservable: (
      currentBalanceAmount: number,
      currentBalanceVersion: number
    ) => Observable<CardTransaction[]>
  ) {
    if (this.cardReaderWebSocket) {
      this.cardReaderWebSocket.close();
    }
    let webSocket: WebSocket = (this.cardReaderWebSocket = new WebSocket(
      this.configService.getCardReaderWebSocketUrl()
    ));
    webSocket.addEventListener('close', (ev: Event) => {
      this.openStoredDataComparisonCardListenerWebSocket();
    });
    webSocket.addEventListener('error', (ev: Event) => {
      if (webSocket.readyState == WebSocket.CLOSED) {
        this.alertsHolder.show('Card reader not found. Set it up and retry.', 'danger');
      } else if (webSocket.readyState == WebSocket.CONNECTING) {
        this.alertsHolder.show('Card reader still connecting. Please wait.', 'danger');
      } else {
        this.alertsHolder.show('Error while reading the card.', 'danger');
        console.error('Card reader error', ev);
      }
      btnEvent.disabled = false;
    });
    webSocket.addEventListener('message', (ev: MessageEvent) => {
      let evData: any = JSON.parse(ev.data);
      switch (evData.messageType) {
        case 'event':
          switch (evData.message.event) {
            case 'UNPROTECTED_CARD_DETECTED':
              this.sendCardReaderHaltCommand(webSocket);
              this.alertsHolder.show('Wrong card.', 'danger');
              btnEvent.disabled = false;
              webSocket.close();
              this.closeInsertCardModal();
              break;
            case 'CARD_DETECTED':
              this.sendCardReaderReadValuesCommand(webSocket, ['CARD_ID', 'CARD_ID_2', 'BALANCE']);
              break;
          }
          break;
        case 'command-response':
          switch (evData.message.request.command) {
            case 'READ_VALUES':
              this.alertsHolder.show('Writing on card, do not remove it.', 'danger');
              if (evData.message.values.cardId == actualCard.uuid || evData.message.values.cardId2 == actualCard.uuid) {
                let balance: { amount: number; version: number };
                let actualCardBalanceCentsBefore: number = this.utils.toCents(actualCard.balance.valueOf());
                if (evData.message.values.cardId == actualCard.uuid) {
                  balance = evData.message.values.balance;
                } else if (evData.message.values.cardId2 == actualCard.uuid) {
                  balance = {
                    amount: actualCardBalanceCentsBefore,
                    version: actualCard.balanceVersion.valueOf(),
                  };
                }
                createAddTransactionObservable(balance.amount, balance.version).subscribe(
                  (data: CardTransaction[]) => {
                    if (evData.message.values.cardId == actualCard.uuid) {
                      let lastTransaction: CardTransaction;
                      if (data && data.length > 0) {
                        lastTransaction = data[0];
                        for (let i: number = 1; i < data.length; i++) {
                          if (data[i].balanceVersion > lastTransaction.balanceVersion) {
                            lastTransaction = data[i];
                          }
                        }
                      }
                      this.backendService.getCard(actualCard.uuid).subscribe(
                        (data) => {
                          actualCard = data;
                          let actualCardBalanceCentsAfter: number = this.utils.toCents(actualCard.balance.valueOf());
                          let newBalance: number =
                            actualCardBalanceCentsAfter - actualCardBalanceCentsBefore + balance.amount;
                          this.sendCardReaderWriteValuesCommand(webSocket, actualCard, newBalance, lastTransaction);
                        },
                        (err: HttpErrorResponse) => {
                          this.alertsHolder.show(
                            'Failed to retreive updated data to align the card, which is now unusable.',
                            'danger'
                          );
                          this.currentTransaction = new CardTransaction();
                          this.transactionProduct = new CardTransactionProduct();
                          btnEvent.disabled = false;
                          this.closeInsertCardModal();
                          this.blockCard(webSocket, actualCard);
                        }
                      );
                    } else if (evData.message.values.cardId2 == actualCard.uuid) {
                      this.loadCurrentCard();

                      this.closeAllModals();
                      this.redirectToCircuit();
                      btnEvent.disabled = false;
                      this.sendCardReaderHaltCommand(webSocket);
                      webSocket.close();
                    }
                  },
                  (err: HttpErrorResponse) => {
                    let alertMessage: string = 'Transaction Rejected';
                    if (err.error.codeNumber === 'APP-025') {
                      actualCard.status = CardStatus.Blocked;
                      this.sendBlockedCardStatusCardReaderWriteValuesCommand(webSocket, this.currentCard);
                      this.alertsHolder.show('The card was automatically blocked.', 'danger');
                    }
                    this.alertsHolder.show(alertMessage, 'danger');
                    this.currentTransaction = new CardTransaction();
                    this.transactionProduct = new CardTransactionProduct();
                    btnEvent.disabled = false;
                    this.sendCardReaderHaltCommand(webSocket);
                    webSocket.close();
                    this.closeInsertCardModal();
                  }
                );
              } else {
                this.alertsHolder.show('Wrong card.', 'danger');
                this.sendCardReaderHaltCommand(webSocket);
                webSocket.close();
                this.closeInsertCardModal();
                btnEvent.disabled = false;
              }
              break;
            case 'WRITE_VALUES':
              if (evData.message.request.parameters.cardId == actualCard.uuid) {
                if (evData.message.request.parameters.cardStatus == 'Blocked') {
                  this.sendCardReaderHaltCommand(webSocket);
                  webSocket.close();
                } else {
                  this.loadCurrentCard();
                  this.closeAllModals();
                  this.redirectToCircuit();
                  btnEvent.disabled = false;
                  this.sendCardReaderHaltCommand(webSocket);
                  webSocket.close();
                  this.alertsHolder.show('Card write success.', 'success');
                }
              }
              break;
          }
          break;
        case 'command-error':
          switch (evData.message.request.command) {
            case 'READ_VALUES':
              if (evData.message.request.parameters.cardId == actualCard.uuid) {
                this.alertsHolder.show('Card read error.', 'danger');
                this.currentTransaction = new CardTransaction();
                this.transactionProduct = new CardTransactionProduct();
                btnEvent.disabled = false;
                this.sendCardReaderHaltCommand(webSocket);
                webSocket.close();
                this.closeInsertCardModal();
              }
              break;
            case 'WRITE_VALUES':
              if (evData.message.request.parameters.cardId == actualCard.uuid) {
                if (evData.message.request.parameters.cardStatus == 'Blocked') {
                  this.sendCardReaderHaltCommand(webSocket);
                  webSocket.close();
                } else {
                  this.alertsHolder.show('Card write error.', 'danger');
                  this.currentTransaction = new CardTransaction();
                  this.transactionProduct = new CardTransactionProduct();
                  btnEvent.disabled = false;
                  this.closeInsertCardModal();
                  this.blockCard(webSocket, actualCard);
                }
              }
              break;
          }
          break;
      }
    });
    webSocket.addEventListener('open', (ev: Event) => {
      this.sendCardReaderHaltCommand(webSocket);
      this.showInsertCardModal(btnEvent);
    });
  }

  redirectToCircuit() {
    if (this.secondCircuit) {
      this.navControllerService.showCardDetails(this.currentCard.secondCircuitUuid, this.accountHolder);
    }
  }

  getSecurityDepositsByCard() {
    this.backendService.getSecurityDepositsByCard(this.currentCard).subscribe(
      (deposits) => {
        this.securityDeposits = deposits;
        this.totalDeposit = this.getSecurityDepositTotal();
      },
      (err: HttpErrorResponse) => {}
    );
  }

  getSecurityDepositTotal(): number {
    let total = 0;
    this.securityDeposits.forEach((transaction) => {
      total += transaction.movement.valueOf();
    });
    return total;
  }

  rechargeTransaction() {
    this.currentTransaction = new CardTransaction();
    this.showRechargeModal();
  }

  paymentTransaction() {
    this.currentTransaction = new CardTransaction();
    this.transactionProduct = new CardTransactionProduct();
    this.showPaymentModal();
  }

  securityDepositTransaction() {
    this.currentTransaction = new CardTransaction();
    this.showSecurityDepositModal();
  }

  dischargeTransaction() {
    this.currentTransaction = new CardTransaction();
    this.currentTransaction.movement = this.currentCard.balance;
    this.showDischargeModal();
  }

  refreshChart() {
    this.chart.labels.length = 0;
    this.chart.data.length = 0;
    let balance = 0;
    if (this.baseChart !== undefined) {
      this.baseChart.ngOnDestroy();
      this.baseChart.chart = this.baseChart.getChartBuilder(this.baseChart.ctx);
    }
    let currentTransactions: CardTransaction[] = this.currentTransactions.slice();
    currentTransactions.sort((a: CardTransaction, b: CardTransaction) => {
      if (a.date < b.date) {
        return -1;
      }
      if (a.date > b.date) {
        return 1;
      }
      return 0;
    });
    currentTransactions.forEach((element) => {
      if (!Object.is(TransactionType.Reversal, TransactionType[element.type]) && !element.reversed) {
        balance += this.getBalanceAmount(element);
        this.chart.labels.push(this.utils.toConfiguredDatetimeStringFormat(element.date));
        this.chart.data.push(balance);
      }
    });
    this.baseChart.chart.update();
  }

  getBalanceAmount(transaction: CardTransaction): number {
    if (
      Object.is(TransactionType.Recharge, TransactionType[transaction.type]) ||
      Object.is(TransactionType.DebtPayoff, TransactionType[transaction.type])
    ) {
      return transaction.movement.valueOf();
    } else {
      return -transaction.movement.valueOf();
    }
  }

  onSearchChange(searchString) {
    this.table.filterBySearchText(searchString);
  }

  closeAllModals() {
    this.closeRechargeModal();
    this.closePaymentModal();
    this.closeDischargeModal();
    this.closeSecurityDepositModal();
    this.closeReverseModal();
    this.closeGiveBackModal();
    this.closeInsertCardModal();
  }

  showDischargeModal() {
    this.dischargeModal.show();
  }

  closeDischargeModal() {
    this.dischargeModal.hide();
  }

  showGiveBackModal() {
    this.giveBackModal.show();
    this.getSecurityDepositsByCard();
  }

  closeGiveBackModal() {
    this.giveBackModal.hide();
  }
  showReverseModal(transaction) {
    this.currentTransaction = transaction;
    this.reversalNotes = '';
    this.reverseModal.show();
  }

  closeReverseModal() {
    this.reverseModal.hide();
  }

  showRechargeModal() {
    this.rechargeModal.show();
  }

  closeRechargeModal() {
    this.rechargeModal.hide();
  }

  showPaymentModal() {
    this.paymentModal.show();
  }

  closePaymentModal() {
    this.paymentModal.hide();
  }

  showSecurityDepositModal() {
    this.securityDepositModal.show();
  }

  closeSecurityDepositModal() {
    this.securityDepositModal.hide();
  }

  showInsertCardModal(buttonToEnableOnCancel: HTMLButtonElement) {
    this.insertCardModal['buttonToEnableOnClose'] = buttonToEnableOnCancel;
    this.insertCardModal.show();
  }

  closeInsertCardModal() {
    if (this.insertCardModal['buttonToEnableOnClose']) {
      (<HTMLButtonElement>this.insertCardModal['buttonToEnableOnClose']).disabled = false;
    }
    delete this.insertCardModal['buttonToEnableOnClose'];
    this.insertCardModal.hide();
  }

  showAccountsOwnersPage() {
    this.navControllerService.showAccountsOwnersPage(this.accountHolder);
  }

  showCouponsPage() {
    this.navControllerService.showCouponsPage(this.currentCard.uuid);
  }

  showCurrentAccount() {
    this.navControllerService.showCurrentAccountDetails(this.currentAccount.uuid);
  }

  showAccountsOwnerDetails() {
    if (this.cardOwner) {
      let ownerType = this.currentCard.type.service ? AccountHolder.User : AccountHolder.Customer;
      this.navControllerService.showAccountsOwnerDetails(this.cardOwner.uuid, ownerType);
    } else {
      this.backendService.getAccountOwnerByCard(this.currentCard).subscribe(
        (owner: Customer | User) => {
          let ownerType = this.currentCard.type.service ? AccountHolder.User : AccountHolder.Customer;
          this.navControllerService.showAccountsOwnerDetails(owner.uuid, ownerType);
        },
        (err: HttpErrorResponse) => {}
      );
    }
  }

  cancelInsertCard() {
    this.cardReaderWebSocket.close();
    this.closeInsertCardModal();
  }

  private openStoredDataComparisonCardListenerWebSocket() {
    if (this.cardReaderWebSocket) {
      this.cardReaderWebSocket.close();
    }
    let webSocket: WebSocket = (this.cardReaderWebSocket = new WebSocket(
      this.configService.getCardReaderWebSocketUrl()
    ));
    webSocket.addEventListener('error', (ev: Event) => {
      if (webSocket.readyState == WebSocket.CLOSED) {
        this.alertsHolder.show('Card reader not found. Set it up and retry.', 'danger');
      } else if (webSocket.readyState == WebSocket.CONNECTING) {
        this.alertsHolder.show('Card reader still connecting. Please wait.', 'danger');
      } else {
        this.alertsHolder.show('Error while reading the card.', 'danger');
        console.error('Card reader error', ev);
      }
    });
    webSocket.addEventListener('message', (ev: MessageEvent) => {
      let evData: any = JSON.parse(ev.data);
      switch (evData.messageType) {
        case 'event':
          switch (evData.message.event) {
            case 'UNPROTECTED_CARD_DETECTED':
              this.alertsHolder.show('Card unrecognized.', 'danger');
              this.sendCardReaderHaltCommand(webSocket);
              break;
            case 'CARD_DETECTED':
              if (evData.message.values.cardId == this.currentCard.uuid) {
                this.sendCardReaderReadValuesCommand(webSocket, [
                  'CARD_ID',
                  'ACTIVATION_TIME',
                  'EXPIRE_TIME',
                  'CARD_TYPE',
                  'USER_ID',
                  'CARD_ID_2',
                  'BALANCE',
                  'CARD_STATUS',
                  'CARD_NAME',
                  'ROOM_NUMBER',
                  'PLAFOND',
                  'OWNER_NAME',
                  'LAST_TRANSACTION',
                  'ALL_COUPONS',
                  'ALL_DAILY_COUPONS',
                ]);
              } else {
                this.sendCardReaderHaltCommand(webSocket);
                this.alertsHolder.show('Wrong card.', 'danger');
              }
              break;
          }
          break;
        case 'command-response':
          switch (evData.message.request.command) {
            case 'READ_VALUES':
              if (evData.message.values.cardId == this.currentCard.uuid) {
                this.dataStoredInCard = evData.message.values;
                this.sendCardReaderHaltCommand(webSocket);
                this.currentCard['ownerLoadingStatus'] = 'loading';
                this.currentCard['lastTransaction'] = 'loading';
                this.currentCard['coupons'] = 'loading';
                this.currentCard['dailyCoupons'] = 'loading';
                this.cardOwner ||
                  this.backendService.getAccountOwnerByCard(this.currentCard).subscribe(
                    (owner: Customer | User) => {
                      this.cardOwner = owner;
                      delete this.currentCard['ownerLoadingStatus'];
                    },
                    (err: HttpErrorResponse) => {
                      this.currentCard['ownerLoadingStatus'] = 'error';
                    }
                  );
                this.backendService.getLastCardTransactionByCard(this.currentCard).subscribe(
                  (lastTransaction: CardTransaction) => {
                    this.currentCard['lastTransaction'] = lastTransaction;
                  },
                  (err: HttpErrorResponse) => {
                    if (err && err.error && err.error.code == 'APP_NO_DATA_FROM_QUERY') {
                      delete this.currentCard['lastTransaction'];
                    } else {
                      this.currentCard['lastTransaction'] = 'error';
                    }
                  }
                );
                this.backendService.getCouponByCard(this.currentCard).subscribe(
                  (coupons: Coupon[]) => {
                    let plainCoupons: Coupon[] = new Array();
                    let dailyCoupons = new Array();
                    for (let coupon of coupons) {
                      if (coupon.type.daily) {
                        dailyCoupons.push(coupon);
                      } else {
                        plainCoupons.push(coupon);
                      }
                    }
                    plainCoupons.sort((a: Coupon, b: Coupon) => {
                      if (a.type.code < b.type.code) {
                        return -1;
                      }
                      if (a.type.code > b.type.code) {
                        return 1;
                      }
                      return 0;
                    });
                    dailyCoupons.sort((a: Coupon, b: Coupon) => {
                      if (a.type.code < b.type.code) {
                        return -1;
                      }
                      if (a.type.code > b.type.code) {
                        return 1;
                      }
                      if (a.date < b.date) {
                        return -1;
                      }
                      if (a.date > b.date) {
                        return 1;
                      }
                      return 0;
                    });
                    type DailyCouponDailyAmount = { date: number; amount: number };
                    type GroupedDailyCoupon = { code: number; dailyAmounts: DailyCouponDailyAmount[] };
                    let dailyCouponsGroupedByCode: GroupedDailyCoupon[] = new Array<GroupedDailyCoupon>();
                    let currentDailyCouponsGroupedByCode: GroupedDailyCoupon = { code: null, dailyAmounts: null };
                    for (let dailyCoupon of dailyCoupons) {
                      if (currentDailyCouponsGroupedByCode.code != dailyCoupon.type.code) {
                        currentDailyCouponsGroupedByCode = {
                          code: dailyCoupon.type.code,
                          dailyAmounts: new Array<DailyCouponDailyAmount>(),
                        };
                        dailyCouponsGroupedByCode.push(currentDailyCouponsGroupedByCode);
                      }
                      currentDailyCouponsGroupedByCode.dailyAmounts.push({
                        date: dailyCoupon.date,
                        amount: dailyCoupon.amount,
                      });
                    }
                    this.currentCard['coupons'] = plainCoupons;
                    this.currentCard['dailyCoupons'] = dailyCouponsGroupedByCode;
                  },
                  (err: HttpErrorResponse) => {
                    if (err && err.error && err.error.code == 'APP_NO_DATA_FROM_QUERY') {
                      delete this.currentCard['coupons'];
                      delete this.currentCard['dailyCoupons'];
                    } else {
                      this.currentCard['coupons'] = 'error';
                      this.currentCard['dailyCoupons'] = 'error';
                    }
                  }
                );
                this.dataStoredInCard.coupons.sort((a, b) => {
                  if (a.code < b.code) {
                    return -1;
                  }
                  if (a.code > b.code) {
                    return 1;
                  }
                  return 0;
                });
                for (let dailyCoupon of this.dataStoredInCard.dailyCoupons) {
                  dailyCoupon.dailyAmounts.sort((a, b) => {
                    if (a.dayOfStay < b.dayOfStay) {
                      return -1;
                    }
                    if (a.dayOfStay > b.dayOfStay) {
                      return 1;
                    }
                    return 0;
                  });
                  let dateOfStay: Date = new Date(0);
                  let expirationDate: Date = new Date(this.dataStoredInCard.expireTime);
                  for (let i: number = 0; i < dailyCoupon.dailyAmounts.length && dateOfStay < expirationDate; i++) {
                    let dailyAmount = dailyCoupon.dailyAmounts[i];
                    dateOfStay = new Date(this.currentCard.activationDate);
                    dateOfStay.setDate(dateOfStay.getDate() + dailyAmount.dayOfStay - 1);
                    if (dateOfStay <= expirationDate) {
                      dailyAmount.date = dateOfStay;
                    }
                  }
                }
                this.dataStoredInCard.dailyCoupons.sort((a, b) => {
                  if (a.code < b.code) {
                    return -1;
                  }
                  if (a.code > b.code) {
                    return 1;
                  }
                  return 0;
                });
                this.showStoredDataComparisonModal();
              } else {
                this.sendCardReaderHaltCommand(webSocket);
                this.alertsHolder.show('Wrong card.', 'danger');
              }
              break;
          }
          break;
        case 'command-error':
          switch (evData.message.request.command) {
            case 'READ_VALUES':
              if (evData.message.request.parameters.cardId == this.currentCard.uuid) {
                this.sendCardReaderHaltCommand(webSocket);
                this.alertsHolder.show('Card read error.', 'danger');
              }
              break;
          }
          break;
      }
    });
    webSocket.addEventListener('open', (ev: Event) => {
      this.sendCardReaderHaltCommand(webSocket);
    });
  }

  showStoredDataComparisonModal() {
    this.storedDataComparisonModal.show();
  }

  closeStoredDataComparisonModal() {
    delete this.currentCard['lastTransaction'];
    delete this.currentCard['coupons'];
    delete this.currentCard['dailyCoupons'];
    this.storedDataComparisonModal.hide();
  }

  isArray(arg: any) {
    return Array.isArray(arg);
  }

  fromCardStoredAmountToDisplayString(amount: number): string {
    let result: string;
    if (amount || amount == 0) {
      let amountString: string = new Number(amount).toFixed(0);
      let integerDigits: string = amountString.substring(0, amountString.length - 2);
      let fractionalDigits: string = amountString.substring(amountString.length - 2);
      if (integerDigits.length == 0) {
        integerDigits = '0';
      }
      fractionalDigits = '0'.repeat(2 - fractionalDigits.length) + fractionalDigits;
      result = integerDigits + '.' + fractionalDigits;
    } else {
      result = '';
    }
    return result;
  }

  getPdf() {
    this.backendService.getCardStatementPdf(this.currentCard.uuid).subscribe(
      (blob: Blob) => {
        const element = document.createElement('a');
        element.href = URL.createObjectURL(blob);
        element.download = this.currentCard.name + ' ' + new Date().toDateString() + '.pdf';
        document.body.appendChild(element);
        element.click();
      },
      (err: HttpErrorResponse) => {}
    );
  }

  getTitle(msg: string) {
    return this.translate.instant(msg);
  }
}



// WEBPACK FOOTER //
// ./src/pages/card-details/card-details.ts